/* eslint-disable react-hooks/exhaustive-deps */

// IMPORTS
import { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { MenuIcon, XIcon, ShoppingBagIcon, InformationCircleIcon as Info } from '@heroicons/react/solid'
import { ArrowDropDown, Close as Cancel, Replay as ReAdd } from '@mui/icons-material';
import { openDB } from 'idb';
import { clearFBDeviceId } from "../firebase/handle_loggedIn_device";
import Context from '../context/context'

// VARIABLES
let summaryPage = window.location.pathname.includes('/kds/summary')
let isSidebarOpen = true;
let selectedFilter = 'All'
let chefSelectedItemGroup = ''
let kotTimeIntervalId = 0
let kotsTime = {}
let blinking_ready_items = { timer: null, items: [] }
let chefSelectedItems = []
let globalScopeOrdersData = []
let highlightTimerIds = []

// CONSTANTS
const options = {
    kdsFiltersOptions: ['All', 'Running Orders', 'First Time Orders']
}

// FUNCTIONS
const blink_ready_items = callback => {
    if (!blinking_ready_items?.items?.length) return blinking_ready_items.timer = null
    blinking_ready_items.timer = setInterval(() => {
        console.log({ blinking_ready_items })
        if (!blinking_ready_items?.items?.length) {
            clearInterval(blinking_ready_items.timer)
            return blinking_ready_items.timer = null
        }

        const remove = id => {
            // document.getElementById(id)?.classList?.remove('blinking-ready-item')
            // document.getElementById(id)?.classList?.remove('ready-item')
            blinking_ready_items = {
                ...blinking_ready_items,
                items: blinking_ready_items?.items?.filter(i => i.id !== id)
            }
        }

        for (const doc of blinking_ready_items?.items) {
            if (!document.getElementById(doc.id)?.classList) {
                remove(doc.id)
                continue
            };
            document.getElementById(doc.id)?.classList?.toggle('blinking-ready-item')
            doc.time += 500
            if (doc.time >= 2500) {
                document.getElementById(doc.id)?.classList?.add('blinking-ready-item')
                remove(doc.id)
                if (!doc?.category) {
                    document.querySelector(`[card-id="${doc.kot_id}"][unready-items='1']`)?.querySelector('button.readybtn')?.click()
                }
                callback()
            }
        }
    }, 500);
}

const filterReadyItems = (i, kot_setup) => {

    const doc = blinking_ready_items?.items?.find(j =>
        (!j.category && j.id === i.kot_item_uuid) ||
        (j.category && j.id === i.item_uuid)
    )

    console.log(`DOC FOUND: ${doc?.id ? true : false}`)
    if (chefSelectedItems !== '0' && !chefSelectedItems?.includes(i.item_uuid)) return null;
    else if (
        +kot_setup?.hide_ready_items !== 1 ||
        +i?.order_item_status === 0 ||
        (doc && doc?.time <= 2500)
    ) return i
    else return null
}

const colorAndCodeHandler = ({ color, code }) => {

    let colorCode = null;
    if (color === 'orange')
        colorCode = 'O'
    if (color === 'red')
        colorCode = 'R'
    if (color === 'black')
        colorCode = 'B'
    if (color === 'blue')
        colorCode = 'E'
    if (color === 'grey')
        colorCode = 'W'
    if (color === 'purple')
        colorCode = 'P'

    let col = null
    if (code === 'O')
        col = 'orange'
    if (code === 'R')
        col = 'red'
    if (code === 'B')
        col = 'black'
    if (code === 'E')
        col = 'blue'
    if (code === 'W')
        col = 'grey'
    if (code === 'P')
        col = 'purple'

    if (color && !code) return colorCode
    if (code && !color) return col
}

const highlightTickets = className => {

    let stop_timer = false;
    let timersArray = [...highlightTimerIds];
    if (timersArray) {
        timersArray.forEach(obj => {

            if (obj.className === className) stop_timer = true;

            clearInterval(obj.id)
            Array.from(document.getElementsByClassName(obj.className))
                .forEach(element => {
                    if (element.classList.contains('ready-item'))
                        element.classList.add('ready-item');

                    element.classList.remove('highlight')
                    element.classList.remove('ticket-blinking')
                })
            console.log("All previous timeouts has been cleared")
        })

        if (stop_timer) return highlightTimerIds = [];
        timersArray = timersArray.filter(obj => obj.className !== className)
    }

    Array.from(document.getElementsByClassName(className))
        .forEach(element => {
            element.classList.remove('blink-deactivate')
        })

    const intervalId = setInterval(() => {
        Array.from(document.getElementsByClassName(className))
            .forEach(element => {

                if (element.classList.contains('blink-deactivate')) return
                if (element.classList.contains('ready-item'))
                    element.classList.add('ready-item');

                element.classList.toggle('highlight')
                element.classList.add('ticket-blinking')
            })
    }, 500);

    highlightTimerIds = [...timersArray, { id: intervalId, className: className }];
}

// COMPONENTS
export default function KdsSystem() {

    const [KDSData, setKDSData] = useState({ orders: [], items: [] })
    const [KDSSetup, setKDSSetup] = useState()
    const [sections, setSections] = useState(null);
    const [seats, setSeats] = useState(null);
    const [forceMount, setForceMount] = useState(null);
    const [IDBItems, setIDBItems] = useState([]);
    const [IDBCategories, setIDBCategories] = useState([]);
    const [IDBOrders, setIDBOrders] = useState([])
    const [kotColorsSetup, setKotColorsSetup] = useState(null)
    const context = useContext(Context);
    const { forceRenderOrdersPage, updateUnSync, generateCoupons, calculateOrderValues } = context;

    summaryPage = window.location.pathname.includes('/kds/summary')
    globalScopeOrdersData = KDSData?.orders

    useEffect(() => {
        const getData = async () => {
            let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
            let tx = db.transaction('item', 'readonly').objectStore('item');
            let IDBItemsList = await tx.getAll();

            tx = db.transaction('user', 'readonly').objectStore('user');
            const selected_group_uuid = (await tx.get(localStorage?.getItem('user_uuid')))?.item_group_uuid

            if (selected_group_uuid?.length > 1) tx = db.transaction('item_grouping', 'readonly').objectStore('item_grouping');
            const itemGroup = selected_group_uuid?.length > 1 ? await tx.get(selected_group_uuid) : null
            chefSelectedItems = itemGroup?.items || '0'
            chefSelectedItemGroup = itemGroup?.item_group_uuid

            tx = db.transaction('running_orders', 'readonly').objectStore('running_orders');
            let orders = (await tx.getAll())?.filter(i => +i?.preparation_status === 0 && +i.order_status === 3);
            console.log({ itemGroup, chefSelectedItems })
            // if (itemGroup?.item_group_uuid) orders = orders?.filter(i => !i.prepared_items_group?.includes(itemGroup?.item_group_uuid))

            tx = db.transaction('outlet', 'readonly').objectStore('outlet');
            let outletData = (await tx.getAll())?.[0];

            tx = db.transaction('seats', 'readonly').objectStore('seats');
            let seats = await tx.getAll();

            tx = db.transaction('category', 'readonly').objectStore('category');
            let categories = await tx.getAll();

            if (outletData.kot_colors?.length > 0) setKotColorsSetup(outletData.kot_colors.sort((a, b) => +a.time - +b.time).map(i => ({ ...i, time: i.time * 60 })))

            setKDSSetup(outletData?.kds_setup)
            generateKDSData(orders, IDBItemsList, outletData?.kds_setup)
            setIDBOrders(orders)
            setIDBCategories(categories)
            invokeKotTimerHandler()
            setIDBItems(IDBItemsList)
            setSections(outletData.section_details)
            setSeats(seats)
        }

        getData();
        return () => {
            clearInterval(kotTimeIntervalId)
            globalScopeOrdersData = []
        }
    }, [forceRenderOrdersPage, forceMount])

    useEffect(() => {

        if (!kotColorsSetup?.[0] || !Array.from(document.querySelectorAll(`[label="kot-item-container"]`))?.[0]) return;
        if (!Array.from(window.document.styleSheets[0].rules).some(i => i.name === 'colorFrames')) {

            const totalTimeSpan = +kotColorsSetup.at(-1).time
            const keyFrames = kotColorsSetup.map(c => (
                `${Math.ceil((+c.time * 100) / totalTimeSpan)}% { background-color: ${c.color}; }`
            ))
            // console.log(keyFrames)
            const css = window.document.styleSheets[0];
            css.insertRule(`@keyframes colorFrames {
                                0% { background-color: #4ac959; }
                                ${keyFrames.join('')}
                            }`, css.cssRules.length);
        }

        if (Array.from(document.querySelectorAll(`[label="kot-item-container"]`))?.[0]?.style?.animation) return
        const totalTimeSpan = +kotColorsSetup.at(-1).time
        Array.from(document.querySelectorAll(`[label='kot-item-container']`))
            ?.forEach(i => {
                const delayTime = Math.ceil((Date.now() - +i.getAttribute('created-at')) / 1000)
                const anime = `colorFrames ${totalTimeSpan}s linear -${delayTime}s 1 alternate forwards`
                i.style.animation = anime
                i.style.WebkitAnimation = anime
            });
    })

    const invokeKotTimerHandler = () => {
        const updateTime = () => {
            if (!globalScopeOrdersData?.[0]) return
            // console.log('no order found', globalScopeOrdersData);
            globalScopeOrdersData?.forEach(kot => {
                if (!document.getElementById(kot?.id)) return;
                let time_gap = new Date(Date.now() - (+kot?.created_at)).toUTCString().slice(17, -3)
                kotsTime = { ...kotsTime, [kot?.id]: time_gap }
                document.getElementById(kot?.id).innerText = time_gap;
            })
        }
        clearInterval(kotTimeIntervalId)
        kotTimeIntervalId = setInterval(updateTime, 1000)
    }

    const generateKDSData = (ordersArray = IDBOrders, IDBItemsList = IDBItems, kds_setup = KDSSetup) => {
        let kotArray = [];
        let itemsArray = [];

        ordersArray?.forEach(order => {
            let kotLength = order.order_kot_details.length
            if (selectedFilter !== 'All' && !(kotLength > 1 && selectedFilter === 'Running Orders') && !(kotLength === 1 && selectedFilter === 'First Time Orders')) return;
            order.order_kot_details?.forEach(kot_order => {

                if (
                    +kot_order?.kot_status !== 0
                    && !kot_order?.kot_items_details?.find(i => +i.order_item_status === 0)
                ) return;

                const kot_id = [order.order_uuid, kot_order.kot].join("+")
                const kot_items = kot_order?.kot_items_details?.filter(i => filterReadyItems(i, kds_setup))

                if (kot_items?.length === 0) return console.warn("NO UNREADY ITEMS FOUND");

                const kot_order_obj = { ...kot_order, kot_items_details: kot_items };
                kot_order_obj.order_uuid = order.order_uuid
                kot_order_obj.local_order_id = order.local_order_id
                kot_order_obj.id = kot_id

                if (order.seat_uuid) kot_order_obj.seat = order.seat_uuid
                else kot_order_obj.order_type = order.order_type

                kotArray.push(kot_order_obj)
                kot_items?.forEach(item => {

                    const item_json = IDBItemsList.find(i => i.item_uuid === item.item_uuid)
                    item.item_name = item_json?.item_name;
                    const obj = {}
                    obj.item_uuid = item.item_uuid;
                    obj.category_uuid = item_json?.category_uuid;
                    obj.order_item_status = item.order_item_status;
                    obj.name = item.item_name;
                    obj.occurances = 1;
                    obj.quantity = item.order_item_qty;
                    obj.status = +item.order_item_status;
                    obj.instruction = item.order_item_instruction ? true : false;
                    obj.addon = item.addon_details && item.addon_details.length > 0 ? true : false;
                    obj.multi = item.multi_details && item.multi_details.length > 0 ? true : false;

                    const existingItem = itemsArray?.find(element => element.name === obj.name)

                    if (existingItem) {

                        existingItem.quantity = +existingItem.quantity + +item.order_item_qty;
                        existingItem.occurances = +existingItem.occurances + 1;

                        if (existingItem.instruction === false) existingItem.instruction = obj.instruction;
                        if (existingItem.addon === false) existingItem.addon = obj.addon;
                        if (existingItem.multi === false) existingItem.multi = obj.multi;
                        if (existingItem.status !== 0 && obj.status !== 2) existingItem.status = obj.status;

                        itemsArray = itemsArray?.filter(i => i.item_uuid !== obj.item_uuid)?.concat([existingItem]) || []
                    }
                    else itemsArray.push(obj)
                })
            })
        });

        kotArray.sort((a, b) => +a.kot - +b.kot);
        itemsArray.sort((a, b) => a.name?.localeCompare(b?.name))
        console.log({ orders: kotArray, items: itemsArray })
        setKDSData({ orders: kotArray, items: itemsArray })
    }

    const filterOrders = filterParam => {
        selectedFilter = filterParam
        generateKDSData()
    }

    const onOrderPrepared = async (db, ordersCollection, refreshData = true) => {

        for (const orderJson of ordersCollection) {
            let order = await calculateOrderValues(orderJson, true)
            order.IsSynched = 0;
            order.order_total = +(+order.order_total).toFixed(+sessionStorage.getItem('decimal_length'));

            if (chefSelectedItems?.length > 0 && chefSelectedItems !== '0')
                if (order.prepared_items_group) order.prepared_items_group = [...order.prepared_items_group, chefSelectedItemGroup]
                else order.prepared_items_group = [chefSelectedItemGroup]

            let tx = db.transaction('running_orders', 'readwrite').objectStore('running_orders');
            if (order.order_status !== 4) {
                await tx.put(order)
                if (order?.seat_uuid) {
                    let onorder_seats = JSON.parse(localStorage.getItem("onorder_seats"));
                    onorder_seats.forEach(seatOrder => {
                        if (seatOrder.seat_uuid === order.seat_uuid) seatOrder.price = order.order_total;
                    });
                    localStorage.setItem("onorder_seats", JSON.stringify(onorder_seats));
                }
                refreshData && setForceMount(Math.random())
                return console.log('order Updated successfully in running order', order)
            }

            await tx.delete(order.IDENTIFIER)

            order.completed_at = Date.now()
            order.IDENTIFIER = order.order_uuid;

            delete order.IsSynched;
            delete order.Sync_Type;

            tx = db.transaction('Orders', 'readwrite').objectStore('Orders');
            await tx.add(order)

            tx = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
            await tx.put({ ...order, IDENTIFIER: `order-new:${order.order_uuid}`, BACKUP: 0 });

            if (order?.customer_mobile) generateCoupons(db, order?.order_uuid, order?.customer_mobile)

            updateUnSync();
            if (order?.seat_uuid) {
                let onorder_seats = JSON.parse(localStorage.getItem("onorder_seats"));
                onorder_seats = onorder_seats.filter(seatOrder => seatOrder.seat_uuid !== order.seat_uuid);
                localStorage.setItem("onorder_seats", JSON.stringify(onorder_seats));
            }

            console.log('order Updated successfully', order)
        }
        setForceMount(Math.random())
    }

    const markItemsInOrders = async (item_uuid, status) => {

        const query = `[category-item="${item_uuid}"]`
        document?.querySelector(query)?.classList?.[+status === 2 ? 'add' : 'remove']('cancelled');
        document?.querySelector(query)?.classList?.[+status === 1 ? 'add' : 'remove']('ready-item');

        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        setIDBOrders(state => {

            for (let IDBOrder of state) {
                for (const kot of IDBOrder?.order_kot_details) {
                    for (const item of kot.kot_items_details) {
                        if (item.item_uuid === item_uuid) item.order_item_status = status
                    }
                    if (!kot.kot_items_details?.some(i => +i.order_item_status === 0)) kot.kot_status = 1
                    else kot.kot_status = 0
                }

                IDBOrder.IsSynched = 0
                IDBOrder = calculateOrderValues(IDBOrder, true, false)
                db.transaction('running_orders', 'readwrite').objectStore('running_orders').put(IDBOrder)
            }

            if (+KDSSetup?.hide_ready_items !== 1) {
                generateKDSData(state)
                return state;
            }

            const onComplete = async () => {
                generateKDSData()
                const preparedOrders = state?.filter(i => !i.order_kot_details?.some(i => +i.kot_status === 0))
                if (preparedOrders?.[0]) await onOrderPrepared(db, preparedOrders, false)
            }

            blinking_ready_items = {
                ...blinking_ready_items,
                items: (blinking_ready_items?.items || [])
                    ?.filter(i => i.id !== item_uuid)
                    ?.concat((+status === 0) ? [] : [{ id: item_uuid, time: 0, category: true }])
            }

            if (!blinking_ready_items?.timer && !(+status === 0)) blink_ready_items(onComplete)
            return state
        })
    }

    return (
        <div className="kds">
            <KdsNav filterOrders={filterOrders} summaryPage={summaryPage} beforePageSwitch={() => ''} />
            <div className="kdscontainer">
                {!summaryPage && <KdsSidebar KDSItems={KDSData?.items} />}
                <div className={`${isSidebarOpen ? "" : "sdopen"} kdsitems ${KDSSetup?.font_size || ''}`}>
                    {!summaryPage
                        ? KDSData?.orders?.map((kot, i) => {
                            let seat;
                            let section;
                            if (kot.seat && seats && sections) {
                                seat = seats?.find(seat => seat.seat_uuid === kot.seat)
                                section = seat && sections?.find(section => section.section_uuid === seat.section_uuid)
                                // if (!seat || !section) return 'No seat found'
                            }

                            return <KOTCard
                                key={kot.id}
                                seat={seat}
                                section={section}
                                kot={kot}
                                itemsList={IDBItems}
                                IDBOrders={IDBOrders}
                                setIDBOrders={setIDBOrders}
                                showColorsPallet={!kotColorsSetup}
                                generateKDSData={generateKDSData}
                                calculateOrderValues={calculateOrderValues}
                                KDSSetup={KDSSetup}
                                onOrderPrepared={onOrderPrepared}
                            />
                        })
                        : KDSData?.items
                            ?.reduce((c, i) => !c.includes(i.category_uuid) ? c.concat([i.category_uuid]) : c, [])
                            ?.map(i => (
                                <CategoryCard
                                    key={i}
                                    detail={{
                                        category_uuid: i,
                                        category_name: IDBCategories?.find(c => c.category_uuid === i)?.category_name,
                                        items: KDSData?.items?.filter(j => j.category_uuid === i)
                                    }} markItemsInOrders={markItemsInOrders} />
                            ))
                    }
                </div>
            </div>
        </div>
    )
}

const KOTCard = ({ seat, section, kot, itemsList, showColorsPallet, KDSSetup, onOrderPrepared, IDBOrders, setIDBOrders, generateKDSData, calculateOrderValues }) => {

    const [headerColor, setHeaderColor] = useState(null)
    const [warningPopupState, setWarningPopupState] = useState({ status: false, count: 0 })

    const markItem = async (kot_item_uuid, status) => {

        let isBlinking = false
        const query = `[kot-item-id="${kot_item_uuid}"]`

        const markElement = status => {
            document?.querySelector(query)?.classList?.[+status === 2 ? 'add' : 'remove']('cancelled');
            document?.querySelector(query)?.classList?.[+status === 1 ? 'add' : 'remove']('ready-item');
        }
        if (document?.querySelector(query)?.classList?.contains('ticket-blinking')) {
            document?.querySelector(query)?.classList?.add('blink-deactivate');
            document?.querySelector(query)?.classList?.remove('highlight');
            document?.querySelector(query)?.classList?.remove('ticket-blinking');
            markElement(1)
            isBlinking = true;
        }

        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        const updateOrderInIDB = async order => await db.transaction('running_orders', 'readwrite').objectStore('running_orders').put(order);
        const getUpdatedState = (doc, state) => [...[...state]?.filter(i => i.order_uuid !== doc.order_uuid), doc]
        const handleBlinking = removeOnly => {
            if (+KDSSetup?.hide_ready_items !== 1) return;
            blinking_ready_items = {
                ...blinking_ready_items,
                items: (blinking_ready_items?.items || [])
                    ?.filter(i => i.id !== kot_item_uuid)
                    ?.concat(removeOnly ? [] : [{ id: kot_item_uuid, kot_id: kot.id, time: 0 }])
            }

            if (!blinking_ready_items?.timer && !removeOnly) blink_ready_items(generateKDSData)
        }

        setIDBOrders(state => {

            let order = state?.find(order => order.order_uuid === kot.order_uuid)
            if (!order) return state;

            for (const kot_item of kot.kot_items_details) {

                kot_item.item_name = itemsList.find(i => kot_item.item_uuid === i.item_uuid)?.item_name
                if (kot_item.kot_item_uuid !== kot_item_uuid) continue;
                if (status) kot_item.order_item_status = +status
                else
                    if (+kot_item.order_item_status === 1 && !isBlinking) {
                        kot_item.order_item_status = "0";
                        delete kot_item.prepared_by;
                    } else if (!+kot_item.order_item_status) {
                        kot_item.order_item_status = '1';
                        kot_item.prepared_by = localStorage.getItem('user_uuid');
                    }

                handleBlinking(+status === 0 || +kot_item.order_item_status === 0)
                if (+kot_item.order_item_status > 0) markElement(+kot_item.order_item_status)
                kot.IsSynched = 0;
                kot_item.updated_at = Date.now();
            }
            console.log('changes made in the kot item status', kot)
            console.log('order total after substracting cancelled amount', order.order_total, order.total_tax_gst, order.total_tax_vat)

            order.IsSynched = 0;
            order.order_kot_details = [...order?.order_kot_details?.filter(i => +i.kot !== +kot?.kot), kot]
            if (status) order = calculateOrderValues(order, true, true)

            updateOrderInIDB(order)
            if (+KDSSetup?.hide_ready_items !== 1) generateKDSData(getUpdatedState(order, state))
            return getUpdatedState(order, state)
        })
    }

    useEffect(() => {
        const color = kot.color ? colorAndCodeHandler({ color: null, code: kot.color }) : 'green';
        setHeaderColor(color)
    }, [])

    const handleHeaderColor = color => {

        const colorCode = colorAndCodeHandler({ color })
        console.log(colorCode);
        setHeaderColor(color);

        let DBOpenReq = indexedDB.open('FoodDo', +localStorage.getItem('IDBVersion') || 1);
        console.log('idb collection opened on', window.location.pathname)
        DBOpenReq.addEventListener('error', (err) => { console.warn(err) });
        DBOpenReq.addEventListener('success', (ev) => {
            let db = ev.target.result
            let tx = db.transaction('running_orders', 'readwrite');
            let store = tx.objectStore('running_orders');

            console.log(kot.order_uuid);

            let current_order = store.get(kot.order_uuid);
            current_order.onsuccess = (e) => {

                let order = e.target.result;
                console.log(order, seat);
                order.IsSynched = 0;
                order.order_kot_details.forEach(kot_order => {

                    if (kot_order.kot === kot.kot) {
                        console.log('found kot', kot_order)

                        if (colorCode) kot_order.color = colorCode;
                        else if (!colorCode) delete kot_order.color;

                        console.log('changes made in the kot item status', kot_order)
                    }
                })
                store.put(order);
            }
        })
    }

    const orderReady = async ({ warning_response }) => {

        const order = await IDBOrders?.find(i => i.order_uuid === kot.order_uuid);
        const unreadyItems = await (await order?.order_kot_details?.find(i => i.kot === kot.kot))
            ?.kot_items_details
            ?.filter(i => +i.order_item_status === 0 && (
                chefSelectedItems === '0' || chefSelectedItems?.includes(i.item_uuid)
            ))?.map(i => i.kot_item_uuid);

        if (unreadyItems?.length > 0)
            if (!warning_response) return setWarningPopupState({ status: true, count: unreadyItems?.length })
            else for (const k of order.order_kot_details) {
                if (+k?.kot === +kot?.kot)
                    for (const item of k.kot_items_details) {
                        if (
                            unreadyItems?.find(i => i === item.kot_item_uuid)
                            && +item?.order_item_status === 0
                        ) item.order_item_status = '2'
                    }
            }

        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        onOrderPrepared(db, [order])
    }

    const unreadyItemsCount = kot?.kot_items_details?.filter(i => +i.order_item_status === 0 || blinking_ready_items?.items?.find(j => j.id === i.kot_item_uuid))?.length
    return (
        <div className="kdsitem" id={kot.kot} card-id={kot.id} unready-items={unreadyItemsCount}>
            <div className={`kdsitemhead ${headerColor || 'green'}`} label="kot-item-container" created-at={kot.created_at}>
                <p id={kot.id}>{kotsTime[kot.id] || '00:00:00'}</p>
                <p>#{kot.kot}</p>
                <p style={{ marginTop: '0' }}>
                    {(seat && section) ? `${section.section_name}:${seat.seat_name}` :
                        +kot?.order_type === 1 ? 'TakeAway' :
                            +kot?.order_type === 2 ? 'Delivery' : ''}
                </p>
                <p style={{ marginTop: '0' }}>{kot?.local_order_id}</p>
            </div>
            <div className={`kdsbody`}>
                {kot?.kot_items_details?.map(item =>
                    <div
                        key={item?.kot_item_uuid || Math.random()}
                        className="kot-item-container"
                    >
                        <div
                            id={item?.kot_item_uuid || item?.item_uuid}
                            kot-item-id={item?.kot_item_uuid || item?.item_uuid}
                            className={`kdsbodyorder ${item.item_name} ${+item?.order_item_status === 1 ? "ready-item" : ''} ${+item?.order_item_status === 2 ? 'cancelled' : ''}`}
                            onClick={e => +item?.order_item_status !== 2 && markItem(item?.kot_item_uuid)}
                        >
                            <h1>
                                {item.order_item_qty}
                                {item.parcel === 'Y' && <>
                                    <span>{'['}</span>
                                    <ShoppingBagIcon
                                        style={{
                                            color: 'green',
                                            height: "20px",
                                            position: 'relative',
                                            top: '5px'
                                        }}
                                    />
                                    <span>{']'}</span>
                                </>}
                                x {item.item_name}
                            </h1>
                            <div className="extrahavetoadd">
                                {item.multi_details?.map((multi, id) => {
                                    return <p key={id}>- {multi.name}</p>
                                })}
                                {itemsList && item.addon_details?.map((addon, id) => {
                                    const item_ = itemsList.find(i => i.item_uuid === addon.item_uuid)
                                    return <p key={id}>+ {item_?.item_name}</p>
                                })}
                            </div>
                            <div className="dontadd">{item.order_item_instruction && <p>[{item.order_item_instruction}]</p>}</div>
                        </div>
                        <div className="action-btns">
                            {+item?.order_item_status === 2 ? <ReAdd
                                className="item-action-btn readd"
                                onClick={e => markItem(item?.kot_item_uuid, '0')}
                            /> : <Cancel
                                className="item-action-btn cancel"
                                onClick={e => markItem(item?.kot_item_uuid, '2')}
                            />}
                        </div>
                    </div>
                )}
            </div>
            <KdsCardFooterItem handleHeaderColor={handleHeaderColor} orderReady={orderReady} showColorsPallet={showColorsPallet} />
            {warningPopupState.status && <div className="warning-popup">
                <div>
                    <XIcon className="warning-cancel" onClick={() => setWarningPopupState({ status: false, count: 0 })} />
                    <div className="warning-text">{warningPopupState.count} unprocessed items will get cancelled !!</div>
                    <button className="warning-confirm-btn"
                        onClick={() => {
                            orderReady({ warning_response: 'process' })
                            setWarningPopupState({ status: false, count: 0 })
                        }}
                    >Confirm</button>
                </div>
            </div>}
        </div>
    )
}

const CategoryCard = ({ detail, markItemsInOrders }) => {

    const { category_name, category_uuid, items } = detail;
    const Navigate = useNavigate();

    return (
        <div className="kdsitem category" key={category_uuid}>
            <div className={`kdsitemhead green`}><p>{category_name}</p></div>
            <div className={`kdsbody`}>
                {items?.map((item, index) => (
                    <div
                        key={item.item_uuid}
                        className="kot-item-container"
                    >
                        <div
                            id={item?.item_uuid}
                            category-item={item?.item_uuid}
                            className={`kdsbodyorder ${item.name} ${item.status === 1 ? "ready-item" : ''} ${+item?.order_item_status === 2 ? 'cancelled' : ''}`}
                            onClick={() => markItemsInOrders(item.item_uuid, item.status === 0 ? '1' : '0')}
                        >
                            <h1>{item.quantity} x {item.name}</h1>
                            <div className="extrabtn">
                                {item.instruction && <button className="blue">Cooking Instruction</button>}
                                {item.addon && <button className="orange">Addon</button>}
                                {item.multi && <button className="green">Multi</button>}
                            </div>
                        </div>
                        <div className="action-btns">
                            <Info
                                className={`item-action-btn info-btn ${item.status === 1 ? 'color-invert' : ''}`}
                                onClick={e => {
                                    Navigate('/kds')
                                    setTimeout(() => highlightTickets(item.name), 250);
                                }}
                            />
                            {item.status === 2 ? <ReAdd
                                className="item-action-btn readd"
                                onClick={() => markItemsInOrders(item.item_uuid, '0')}
                            /> : <Cancel
                                className="item-action-btn cancel"
                                onClick={() => markItemsInOrders(item.item_uuid, '2')}
                            />}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

const KdsNav = ({ filterOrders, summaryPage, beforePageSwitch }) => {

    const Navigate = useNavigate();
    const [logoutPopupState, setLogoutPopupState] = useState(false)
    const logout = async () => {
        await clearFBDeviceId()
        sessionStorage.clear();
        window.location.pathname = '/login'
    }

    return (
        <>
            <div className="kdsnav">
                <div className="kdsnavicons">
                    {!summaryPage ? <MenuIcon onClick={() => {
                        isSidebarOpen = !isSidebarOpen
                        let action = 'add'
                        if (isSidebarOpen) action = 'remove'
                        document.querySelector('.kdsitems')?.classList[action]('sdopen')
                        document.querySelector('.kdssidebar')?.classList[action]('hidden')
                    }} className="menuicon" /> : <div></div>}
                    <h1>Kitchen Display</h1>
                    <div className="custom-select-container" style={{ flexDirection: "row", gap: ".5rem" }}>
                        <Filters filterOrders={filterOrders} />
                        <button id="switchpage-btn" onClickCapture={() => beforePageSwitch()} onClick={() => Navigate(summaryPage ? '/kds' : '/kds/summary')}>{summaryPage ? 'KOTs' : 'Summary'}</button>
                    </div>
                    <XIcon className="menuicon" onClick={() => +localStorage.getItem('user_type') === 3 ? setLogoutPopupState(true) : Navigate(sessionStorage?.getItem('selected-page') || '/page1')} />
                </div>
            </div>
            {logoutPopupState && <div className="warning-popup" style={{ zIndex: '1' }}>
                <div style={{ paddingTop: '35px' }}>
                    <div className="warning-text">You will be logged out, confirm?</div>
                    <div id='chef-logout-btns'>
                        <button className="warning-confirm-btn yes" onClick={logout}>Yes</button>
                        <button className="warning-confirm-btn no" onClick={e => setLogoutPopupState(false)}>No</button>
                    </div>
                </div>
            </div>}
        </>
    )
}

const Filters = ({ filterOrders }) => {
    const [optionsToggleState, setOptionsToggleState] = useState({ selected: selectedFilter, visible: false })
    const toggleOptions = param => setOptionsToggleState(doc => ({ ...doc, visible: param === 1 ? false : !doc.visible }))
    const onSelect = e => {
        setOptionsToggleState({ visible: false, selected: e.target.innerText })
        filterOrders(e.target.innerText)
    }
    return (
        <button className="select" autoFocus={true} onBlur={e => toggleOptions(1)}>
            <p className={`selected ${optionsToggleState?.visible ? 'active' : ''}`} onClick={toggleOptions}>{optionsToggleState?.selected} <ArrowDropDown /></p>
            {optionsToggleState?.visible ?
                <div className="options">
                    {options?.kdsFiltersOptions?.map(option => (
                        <div
                            className={`option ${optionsToggleState?.selected === option ? 'selected-option' : ''}`}
                            onClick={onSelect}
                        >{option}</div>
                    ))}
                </div> : ''}
        </button>
    )
}

const KdsCardFooterItem = ({ handleHeaderColor, orderReady, showColorsPallet }) => {
    return (
        <div className="kdsfoot" style={{ justifyContent: showColorsPallet ? 'space-between' : 'center' }}>
            {showColorsPallet ? <div className="colors">
                <button onClick={() => handleHeaderColor('orange')} className="color orange"></button>
                <button onClick={() => handleHeaderColor('red')} className="color red"></button>
                <button onClick={() => handleHeaderColor('green')} className="color green"></button>
                <button onClick={() => handleHeaderColor('black')} className="color black"></button>
                <button onClick={() => handleHeaderColor('blue')} className="color blue"></button>
                <button onClick={() => handleHeaderColor('grey')} className="color grey"></button>
                <button onClick={() => handleHeaderColor('purple')} className="color purple"></button>
            </div> : ''}
            <button className="readybtn" onClick={orderReady}>Ready</button>
        </div>
    )
}

const KdsSidebar = ({ KDSItems }) => (
    <div className={`kdssidebar ${isSidebarOpen ? '' : 'hidden'}`}>
        {<>
            <div className="itemssummary">
                <h1>Summary</h1>
            </div>
            <div className="mapcat" style={{ padding: KDSItems?.length ? '0.5rem 1rem' : '0px' }}>
                {
                    KDSItems && KDSItems.map((item) => {
                        return <div
                            key={item.item_uuid}
                            id={item.item_uuid}
                            className="tableorderlist"
                            onClick={() => highlightTickets(item.name)}
                        >
                            <p>{item.quantity} x {item.name}</p>
                            <p>[{item.occurances} KOT]</p>
                            <div className="extrabtn">
                                {item.instruction && <button className="blue">Cooking Instruction</button>}
                                {item.addon && <button className="orange">Addon</button>}
                                {item.multi && <button className="green">Multi</button>}
                            </div>
                        </div>
                    })
                }
            </div>
        </>}
    </div>
)